<template>
  <div>
    <Tabs v-model="currentTabPane" size="small" class="text-white">
        <TabPane v-for="category in categories"  :key="category.categoryId" :label="category.category === 'detail'?'订单详情':category.category+'采购详情'" :name="category.category">
        </TabPane>
    </Tabs>

    <template v-if="orderId">
      <purchaseInfo v-if="currentTabPane==='detail'" :orderId="orderId" :products="products"/>
      <div v-else>
        <component :is="getTabpaneComponent(curCategory.categoryId)" :schedules="curCategory.schedules" :orderId="orderId" @on-detatil-postsite="handleShowDetailPostSite"></component>
      </div>
    </template>
  </div>
</template>

<script>
import { sysMixins } from '@/assets/mixins/sys'
import purchaseInfo from '@/components/order/details/PurchaseInfo2'
import plat from '@/components/order/details/Plat'
import electronic from '@/components/order/details/Electronic'
import train from '@/components/order/details/Train'
import theme from '@/components/order/details/Theme'
import group from '@/components/order/details/Group'

import { buildCategoriesOrder } from '@/utils/orderUtils'
import { getProductPrice } from '@/api/order/orderprice'
import { getPublisherAssetList } from '@/api/rim/asset'

export default {
  mixins: [sysMixins],
  components: {
    purchaseInfo, plat, train, theme, electronic, group
  },
  data () {
    return {
      currentTabPane: 'detail',
      categories: [],
      products: [],
      curCategory: null,
      currentAllAssets: []
    }
  },
  mounted () {
    this.initPurchaseList()
    this.initPageShowAssets()
  },
  methods: {
    initPurchaseList () {
      this.spinShow = true
      // this.products = []
      // 获取订单的价格清单和档期明细
      getProductPrice({ orderId: this.orderId }).then(res => {
        this.products = res
        const categories = buildCategoriesOrder(res)
        categories.unshift({
          category: 'detail',
          categoryId: 0
        })
        this.categories = categories.map(x => {
          return Object.assign({}, x, { shown: false })
        })
        this.spinShow = false
      })
    },
    initPageShowAssets () {
      getPublisherAssetList().then(res => {
        if (res && !res.errcode) {
          this.currentAllAssets = res.map(x => x.id)
          this.$store.commit('set_openmarketorder_show_assets', this.currentAllAssets)
        }
      })
    },
    getTabpaneComponent (category) {
      this.$store.commit('set_openmarketorder_categoryId', category)
      const componentMap = {
        1: 'plat', // 传统媒体，包含列车
        2: 'train', // 列车
        4: 'theme', // B类， 主题媒介
        7: 'group', // 套装
        8: 'electronic' // 电子媒体
      }

      return componentMap[category] || 'plat'
    },
    handleShowDetailPostSite (stations) { // 地图显示投放详情
      this.$store.commit('set_openmarketorder_update_map', new Date())
      this.$store.commit('set_openmarketorder_stations', stations)

      // 更新显示线路
      const assetIds = []
      stations.forEach(element => {
        if (!assetIds.includes(element.rimAssetId)) {
          assetIds.push(element.rimAssetId)
        }
      })

      this.$store.commit('set_openmarketorder_show_assets', assetIds.length > 0 ? assetIds : this.currentAllAssets)
    }
  },
  computed: {
    orderId () {
      return this.$store.state.openmarketorder.orderId
    }
  },
  watch: {
    currentTabPane: function () {
      if (this.currentTabPane === 'detail') {
        this.handleShowDetailPostSite([])
      } else {
        this.curCategory = this.categories.find(x => x.category === this.currentTabPane)
        // this.setMapComponent('centerComponent')
      }
    }
  }
}
</script>
